module.exports = __webpack_public_path__ + "static/media/Instagram_Glyph_Black.81e0d8a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Instagram_Glyph_Black.svg
// module id = 31
// module chunks = 0